import {
  Row,
  Card,
  Col,
  Image,
  Form,
  Input,
  DatePicker,
  Button,
  Switch,
  Checkbox,
  Skeleton,
  notification
} from "antd";
import { PlusOutlined, DeleteOutlined, CalendarOutlined, CheckCircleOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import * as invoiceService from "../../services/AllInvoices";
import * as inspectorService from "../../services/InspectorDataService";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import moment from 'moment';
import PlaceHolderImg from "../../assets/images/logoPlaceholder.png";
import FormattedCurrencyInput from "../../components/FormattedCurrencyInput";
const UpdateInvoice = () => {
  let navigate = useNavigate();
  var dispatch = useDispatch();
  const [rows, setRows] = useState();
  const columnsArray = ["service", "amount"];
  const [loadings, setLoadings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [inspectorData, setInspectorData] = useState();
  const [checked, setChecked] = useState(false);
  const [showHomeowner, setShowHomeowner] = useState(true);
  const [invoiceData, setInvoiceData] = useState();
  const [form] = Form.useForm();
  const [valuesDate, setValuesDate] = useState({});
  const [calOpen, setCalOpen] = useState(false);

  console.info("invoicedata", invoiceData);

  const queryParams = new URLSearchParams(window.location.search);
  const invoice_id = queryParams.get("invoice_id");

  const getInvoiceData = () => {
    dispatch(invoiceService.getInvoiceData(invoice_id))
      .then((res) => {
        setInvoiceData(res);
        console.warn('res.invoice_date', typeof res.invoice_date);
        setRows(res.servicerepeater ? res.servicerepeater : []);
        setValuesDate(
          {
            ...valuesDate,
            "invoice_date": res.invoice_date ? moment(res.invoice_date).format('MM-DD-YYYY') : ''
          }
        )
        const isChecked = res.show_homeowner === '1';
        const autoGenChecked = res.checkinv === '1' || res.checkinv === 1 || res.checkinv === true;
        
        form.setFieldsValue({
          claim: res.claimnumber,
          company_name: res.company_name,
          client_name: res.client_name,
          addressdiv: res.addressdiv,
          phone_personal: res.phone_personal,
          email_address: res.email_address,
          invoice_notes: res.invoice_notes,
          h_eu_name: res.h_eu_name,
          h_eu_street: res.h_eu_street,
          h_eu_city: res.h_eu_city,
          h_eu_stateProvince: res.h_eu_stateProvince,
          h_eu_country: res.h_eu_country,
          zip_code: res.zip_code,
          total: parseFloat(res.total),
          show_homeowner: isChecked,
          checkinv: autoGenChecked
        });
        setChecked(autoGenChecked);
        setShowHomeowner(isChecked);
        //setRows(res.servicerepeater);
        console.warn('Rows2', rows);
      })
      .catch((err) => {
          // Extract and display a meaningful error message
      let errorMessage;

      if (err.response) {
        // The request was made and the server responded with a status code outside of the 2xx range
        errorMessage = `Error ${err.response.status}: ${err.response.data.message || err.response.statusText}`;
      } else if (err.request) {
        // The request was made but no response was received
        errorMessage = "No response received from the server. Please check your network connection.";
      } else {
        // Something else happened while setting up the request
        errorMessage = `An unexpected error occurred: ${err.message}`;
      }

      // Display the error message in an alert or use a UI notification component
      alert(errorMessage);
      });
  }
  const fetchData = (params = {}) => {
    setLoading(true);
    dispatch(inspectorService.getInspectorData())
      .then((res) => {
        setInspectorData(res);
        setLoading(false);
      })
      .catch((err) => {
        console.info("Get Error Edit State...", err);
        setLoading(false);
      });
  }

  const invoiceCheck = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    form.setFieldsValue({ checkinv: isChecked });
  }

  const enterLoading = (index) => {
    setLoadings((prevLoadings) => {
      const newLoadings = [...prevLoadings];
      newLoadings[index] = true;
      return newLoadings;
    });
    setTimeout(() => {
      setLoadings((prevLoadings) => {
        const newLoadings = [...prevLoadings];
        newLoadings[index] = false;
        return newLoadings;
      });
    }, 6000);
  };

  const handleAddRow = () => {
    const item = {};
    setRows([...rows, item]);
  };

  const handleRemoveSpecificRow = (idx) => {
    const tempRows = [...rows];
    tempRows.splice(idx, 1);
    setRows(tempRows);
  };

  const DateFormat = "MM-DD-YYYY";

  const updateState = (e) => {
    let prope = e.target.attributes.column.value;
    let index = e.target.attributes.index.value;
    let fieldValue = e.target.value;
    const tempRows = [...rows];
    const tempObj = rows[index];
    tempObj[prope] = fieldValue;
    tempRows[index] = tempObj;
    setRows(tempRows);
    let ammmt = rows.map(item => item.amount).reduce((prev, next) => parseFloat(prev) + parseFloat(next));
    const totalValue = parseFloat(ammmt).toFixed(2);
    form.setFieldsValue({
      total: totalValue,
    });
  };

  const onFinish = (values) => {
    const queryParams = new URLSearchParams(window.location.search);
    const invoice_id = queryParams.get('invoice_id');
    values.invoice_id = invoice_id;
    values.logo_invoice = inspectorData.logo;
    values.invoice_organization_name = inspectorData.organization_name;
    values.invoice_address = inspectorData.address;
    values.invoice_phone_number = inspectorData.phone_number;
    values.invoice_email = inspectorData.email;
    values.invoice_extra_notes = inspectorData.invoice_extra_notes;
    values.invoice_date = valuesDate.invoice_date;
    values.checkinv = checked ? 1 : 0;
    enterLoading(0);
    dispatch(invoiceService.updateInvoices(values))
      .then((res) => {
        console.warn("Submit", res);
        notification.open({
          message: "Invoice successfully updated!",
          description: 'You have successfully updated a invoice.',
          icon: (
            <CheckCircleOutlined 
              style={{
                color: '#108ee9',
              }}
            />
          ),
        });
        navigate("/report-invoice/?invoice_id=" + res.data.invoice_id);
      })
      .catch((err) => {
          // Extract and display a meaningful error message
      let errorMessage;

      if (err.response) {
        // The request was made and the server responded with a status code outside of the 2xx range
        errorMessage = `Error ${err.response.status}: ${err.response.data.message || err.response.statusText}`;
      } else if (err.request) {
        // The request was made but no response was received
        errorMessage = "No response received from the server. Please check your network connection.";
      } else {
        // Something else happened while setting up the request
        errorMessage = `An unexpected error occurred: ${err.message}`;
      }

      // Display the error message in an alert or use a UI notification component
      alert(errorMessage);
      });
  };

  const handleDateformate = (e, name, type) => {
    if (
      name === 'invoice_date'
    ) {
      if (type === 'date') {
        setCalOpen(false);
        let date = moment(e).format('MM-DD-YYYY');
        setValuesDate({ ...valuesDate, [name]: date });
        console.log('date', date, valuesDate);
      } else {
        let value = e.target.value;
        setValuesDate({ ...valuesDate, [name]: value });
      }

    }
    console.info('arra', e, name, type);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    fetchData();
    getInvoiceData();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="singleReportWrapper">
      <div className="pageHeader">
        <PageHeader title="Update Invoice" type="secondary" />
      </div>
      <div className="container-xxl">
        {loading ?
          (
            <div className="">
            <div className="Skeleton_invoice">
                <Row gutter={16} className="mb-4 mt-4" justify="space-between">
                  <Col xs={24} md={8} xl={8} className="">
                    <Row gutter={16} className="mb-3">
                      <Col xs={24} md={18} xl={18} className="">
                      <Skeleton.Input block={true} active size="large" style={{height:"90px" }}/>
                      </Col>
                      <Col xs={24} md={6} xl={6} className="">
                      </Col>
                    </Row>
                    <Row gutter={16} className="" >
                      <Col xs={24} md={12} xl={12} className="sklpad">
                      <Skeleton />
                      </Col>
                      <Col xs={24} md={12} xl={12} className="sklpad">
                      </Col>
                    </Row>
                    <Row gutter={16} className="mt-3" >
                      <Col xs={24} md={24} xl={24}>
                      
                    <Row gutter={16} className="mt-4 mb-1">
                    <Col xs={24} md={24} xl={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                    </Row>
                    <Row gutter={16} className="mb-1">
                    <Col xs={24} md={24} xl={24} >
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                    </Row>
                    <Row gutter={16} className="mb-1">
                    <Col xs={24} md={24} xl={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                    </Row>
                    <Row gutter={16} className="">
                    <Col xs={24} md={24} xl={24}>
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                    </Row>
                      </Col>
                      <Col xs={24} md={12} xl={12} className="sklpad">
                      </Col>
                    </Row> 
                  </Col>
                  <Col xs={24} md={6} xl={6} className="">
                    <Row gutter={16} className="">
                    <Col xs={24} md={24} xl={24} className="sklpad">
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                    </Row>
                    <hr></hr>
                    <Row gutter={16} className="mt-4 mb-4">
                    <Col xs={24} md={24} xl={24} className="sklpad">
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                    </Row>
                    <Row gutter={16} className="mb-4">
                    <Col xs={24} md={24} xl={24} className="sklpad">
                      <Skeleton.Input block={true} active size="large" />
                    </Col>
                    </Row>
                    
                  </Col>
                </Row>
                <Row gutter={16} className="mb-2">
                  <Col md={24}>
                  <Skeleton.Input block={true} active size="large" style={{height:"100px" }}/>
                  </Col>
                </Row>
                <Row gutter={16} className="mb-2">
                  <Col md={24}>
                  <Skeleton.Input block={true} active size="large" style={{height:"100px" }}/>
                  </Col>
                </Row>
                <Row gutter={16} className="mb-5 text-right_avatar" justify="right">
                  <Col xs={24} md={24} xl={24} className="text-right_avatar">
                  <Skeleton.Avatar active size="default" />
                  </Col>
                  
                </Row>
                <Row gutter={16} className="mb-5" justify="space-between">
                  <Col xs={24} md={18} xl={8} className="">
                  </Col>
                  <Col xs={24} md={6} xl={6} className="sklpad">
                  <Skeleton.Input block={true} active size="large" />
                  </Col>
                </Row>
                <Row gutter={16} className="mb-4">
                  <Col md={24}>
                  <Skeleton.Input block={true} active size="large" style={{height:"130px" }}/>
                  </Col>
                </Row>
                <Row gutter={16} className="mb-5" justify="center">
                  <Col xs={24} md={10} xl={10} className="sklpad">
                  
                  </Col>
                  <Col xs={24} md={4} xl={4} className="sklpad">
                  <Skeleton.Input block={true} active size="large" />
                  </Col>
                  <Col xs={24} md={10} xl={10} className="sklpad">
                  </Col>
                </Row>
              </div>
            </div>
          ) : (
            <div className="srWrapperInner">
              <Form
                name="report"
                autoComplete="off"
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{
                  show_homeowner: true,
                }}
                form={form}
              >
                <Card className="reportCard  invoice-section-card-content" id="quickReportContent">
                  <div className="reportCardBody">
                    <div className="inspectorInfo">
                      <Row gutter={30}>
                        <Col xs={24} md={6}>
                          <div className="inspectorLogo">
                            <Image
                              src={inspectorData?.logo_url ? inspectorData.logo_url : PlaceHolderImg}
                              className="ing-fluid mb-2"
                              alt="InspectorLogo"
                              preview={false}
                            />
                            <div className="inspectorInformation">
                              <p className="insOrgName">{inspectorData?.organization_name}</p>
                              <p>{inspectorData?.address}</p>
                              <p>{inspectorData?.phone_number}</p>
                              <p>{inspectorData?.email}</p>
                            </div>
                          </div>
                        </Col>
                        <Col sx={24} md={12}></Col>
                        <Col xs={24} md={6}>
                          <div className="inspectorDetails">
                            <div className="inspecDetailHead">
                              <h5 className="inspcTitle">Invoice</h5>
                            </div>
                            <div className="inspcInfo">
                              <div className="formGroup">
                                <Form.Item label="Claim#" name="claim" className="mb-0">
                                  <Input
                                    placeholder="Claim Number"
                                    className="formControl"
                                  />
                                </Form.Item>
                              </div>
                              <div className="formGroup">
                                <Form.Item label="Date" name="invoice_date" className="mb-2 mt-2">
                                  <Input.Group compact className="mt-0">
                                    <Input
                                      placeholder="Date"
                                      className="formControl"
                                      onChange={(e) =>
                                        handleDateformate(
                                          e,
                                          'invoice_date',
                                          'text'
                                        )
                                      }
                                      value={valuesDate.invoice_date}
                                      onFocus={() => setCalOpen(!calOpen)}
                                      onKeyUp={() => setCalOpen(false)}
                                      onBlur={() => setCalOpen(false)}
                                    />

                                    <Button
                                      className="btnAddOn"
                                      icon={<CalendarOutlined />}
                                      onClick={() => setCalOpen(!calOpen)}
                                    />
                                  </Input.Group>
                                  <DatePicker
                                    className="formControl dateHide"
                                    format={DateFormat}
                                    open={calOpen}
                                    style={{ visibility: 'hidden', width: 0 }}
                                    onChange={(e) =>
                                      handleDateformate(
                                        e,
                                        'invoice_date',
                                        'date'
                                      )
                                    }
                                  />
                                </Form.Item>
                              </div>
                              <div className="formGroups">
                                <Form.Item
                                  name="checkinv"
                                  valuePropName="checked"
                                >
                                  <Checkbox 
                                    checked={checked}
                                    onChange={invoiceCheck}
                                  >
                                    Auto Generate Invoice Number?
                                  </Checkbox>
                                </Form.Item>
                              </div>
                              {!checked ?
                                <div className="formGroup">
                                  <Form.Item label="Invoice#" name="invoice_no" className="mb-0">
                                    <Input
                                      placeholder="Invoice#"
                                      className="formControl"
                                    />
                                  </Form.Item>
                                </div> : ''}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <div className="inspectorDetails">
                      <div className="inovicecards my-3">
                        <Row gutter={16}>
                          <Col xs={24} md={8} xl={8}>
                            <p className="siboxheading">Bill To</p>
                            <Form.Item name="client_name" className="mb-2">
                              <Input
                                placeholder="Company"
                                className="formControl"
                              />
                            </Form.Item>
                            <Form.Item name="company_name" className="mb-2">
                              <Input
                                placeholder="Company"
                                className="formControl"
                              />
                            </Form.Item>
                            <Form.Item name="addressdiv" className="mb-2">
                              <Input
                                placeholder="Address"
                                className="formControl"
                              />
                            </Form.Item>
                            <Form.Item name="phone_personal" className="mb-2">
                              <Input
                                placeholder="Phone"
                                className="formControl"
                              />
                            </Form.Item>
                            <Form.Item name="email_address" className="mb-2">
                              <Input
                                placeholder="email"
                                className="formControl"
                                type="email"
                              />
                            </Form.Item>
                          </Col>

                          {invoiceData?.gc_subdivision && invoiceData?.gc_subdivision[0] !== null && invoiceData?.gc_subdivision[0][0] !== ''  ? (
                            <Col xs={24} md={8} xl={8}>
                              <p className="siboxheading">Sub Division</p>
                              <Card className="inovicecard">
                                <div>
                                {Array.isArray(invoiceData?.gc_subdivision[0]) ? invoiceData?.gc_subdivision[0].map(name => <p> {name} </p>) : invoiceData?.gc_subdivision[0]}
                                </div>
                              </Card>
                            </Col>
                          ) : (
                            ""
                          )}

                          {invoiceData?.gc_lotnumber && invoiceData?.gc_lotnumber[0] !== null && invoiceData?.gc_lotnumber[0][0] !== '' ? (
                            <Col xs={24} md={8} xl={8}>
                              <p className="siboxheading">Lot Number</p>
                              <Card className="inovicecard">
                                <div>
                                {Array.isArray(invoiceData?.gc_lotnumber[0]) ? invoiceData?.gc_lotnumber[0].map(name => <p> {name} </p>) : invoiceData?.gc_lotnumber[0]}
                                </div>

                              </Card>
                            </Col>
                          ) : (
                            ""
                          )}
                        </Row>
                      </div>
                    </div>
                    <div className="invoice-home-owner-details mb-3">
                      <div>
                        <div className="mb-3">
                          <Form.Item
                            name="show_homeowner" valuePropName="checked" className="mb-0">
                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Switch
                                  checked={showHomeowner}
                                  onChange={(checked) => {
                                    setShowHomeowner(checked);
                                    form.setFieldsValue({ show_homeowner: checked });
                                  }}
                                  checkedChildren="Show"
                                  unCheckedChildren="Hide"/>
                                 <h6 style={{ margin: 0 }}>Homeowner Details</h6>
                              </div>                       
                          </Form.Item>
                          
                        </div>
                        <div style={{display: showHomeowner ? 'block' : 'none'}}>
                          <h5 className="inspcTitle me-3">Homeowner/End-User Information</h5>
                        <Row gutter={16}>
                          <Col xs={24} md={8} xl={8}>
                            <Form.Item name="h_eu_name" className="mb-2">
                              <Input
                                placeholder="Homeowner/End-User Name"
                                className="formControl"
                              />
                            </Form.Item>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <Form.Item name="h_eu_street" className="mb-2">
                              <Input
                                placeholder="Street Name/Number"
                                className="formControl"
                              />
                            </Form.Item>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <Form.Item name="h_eu_city" className="mb-2">
                              <Input
                                placeholder="City"
                                className="formControl"
                              />
                            </Form.Item>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <Form.Item name="h_eu_stateProvince" className="mb-2">
                              <Input
                                placeholder="State/Province"
                                className="formControl"
                              />
                            </Form.Item>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <Form.Item name="h_eu_country" className="mb-2">
                              <Input
                                placeholder="Country"
                                className="formControl"
                              />
                            </Form.Item>
                            
                          </Col>
                          <Col xs={24} md={8} xl={8}>
                            <Form.Item name="zip_code" className="mb-2">
                              <Input
                                placeholder="Zip/Postal Code"
                                className="formControl"
                              />
                            </Form.Item>
                            
                          </Col>

                          </Row>
                        </div>
                      </div>
                    </div>                 
                  </div>
                  <div className="invoiceTable">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          {columnsArray.map((column, index) => (
                            <th className="text-center" key={index}>
                              {column}
                            </th>
                          ))}
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows && rows?.map((item, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            {columnsArray?.map((column, index) => (

                              <td key={index}>
                                <Form.Item name={[column, idx]} className="mb-0" key={index} initialValue={item[column]}>
                                  <Input
                                    placeholder={column}

                                    index={idx}
                                    className="formControl mb-0"
                                    column={column}
                                    onChange={(e) => updateState(e)}
                                    prefix={column === "amount" ? "$" : undefined}
                                  />
                                </Form.Item>
                              </td>
                            ))}
                            <td>
                              <Button
                                type="btn"
                                shape="circle"
                                icon={<DeleteOutlined />}
                                onClick={() => handleRemoveSpecificRow(idx)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="crbtn">
                      <Button
                        type="btn"
                        shape="circle"
                        icon={<PlusOutlined />}
                        className="repeatorbtn"
                        onClick={handleAddRow}
                      />
                    </div>
                  </div>
                  <div className="custom-Content">
                    <Row gutter={16} className="crbtn">
                      <Col xs={24} md={6} xl={6}>
                        <div className="formGroup total-balance-box">
                          <Form.Item label="Balance Due:" name="total">
                            <FormattedCurrencyInput className="formControl" />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col xs={24} md={24} xl={24}>
                        <div className="formGroup">
                          <Form.Item label="Notes" name="invoice_notes"  className="invoice-notes">
                            <Input.TextArea
                              placeholder="Notes"
                              className="formControl"
                            />
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col xs={24} md={24} xl={24}>
                        
                        {inspectorData?.invoice_extra_notes !== "" ? (
                          <div className="formGroup">
                            <pre>{inspectorData?.invoice_extra_notes}</pre>
                          </div>
                        ) : (
                          <div className="formGroup"></div>
                        )}
                      </Col>
                    </Row>
                    <Row gutter={16} className="crbtn">
                      <Col xs={24} md={24}>
                        <div className="text-center my-3">
                          <Button htmlType="submit" loading={loadings[0]} className="btnPrimary"> Save and Continue</Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Form>
            </div>
          )
        }
      </div>
    </div>
  );
};
export default UpdateInvoice;